import apiClient from './api';

// Cover letter Preferences (length, tone, greeting, sample letter...).
// GET returns { preferences, categories }; PATCH saves only the keys sent.
export default {
  async get() {
    const response = await apiClient.get('/cover-letter-preferences/');
    return response.data;
  },

  async save(updates) {
    const response = await apiClient.patch('/cover-letter-preferences/', updates);
    return response.data.preferences;
  },
};
